module.exports = __webpack_public_path__ + "static/media/back.a744d422.svg";